import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import BasePaymentModal from './BasePaymentModal';

const OnboardingModal = ({ onClose }) => {
  const { t } = useContext(ConfigContext);

  return (
    <BasePaymentModal
      onClose={onClose}
      title={t('onboardingWelcometoUbeyaHeader')}
      subTitleContent={t('onboardingWelcometoUbeyaDescription')}
      footerText={t('onboardingWelcometoUbeyaBIllingAgreement')}
    />
  );
};

export default OnboardingModal;
